import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import EventsWrapper from 'agency/digital_renderer/components/EventsWrapper'
import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import ElementContainer from '../../ElementContainer'

const findContainer = items => items.find(item => item.item_type === 'container')

const filterEvents = (events, filters) => {
  const { limit, offset } = filters || {}

  const filterOffset = offset && offset !== 0 ? offset : 0
  const filterLimit = limit ? limit + filterOffset : null

  const limited = filterLimit ? events.slice(filterOffset, filterLimit) : events.slice(filterOffset)

  return limited
}

const getDatePart = (event, part) => {
  if (event.dates && event.dates.date.date){
    const date = moment(event.dates.date.date, 'DD/MM/YYYY')
    if (date && part === 'month') return date.format('MMM').toUpperCase()
    if (date && part === 'day') return date.format('DD')
  }

  return ''
}

const renderEvents = (container, events) => events.map((event) => {
  const eventContext = {
    ...event,
    month: getDatePart(event, 'month'),
    day: getDatePart(event, 'day'),
  }

  return (
    <div key={event.id} style={deviceStyle(container)}>
      <ElementContainer
        forwardContextToItems={eventContext}
        section={container}
        renderNested
        render={({ itemComponents }) => itemComponents.map(component => component)}
      />
    </div>
  )
})

const Timeline = (props) => {
  const { items, options } = props

  const { limit, offset } = options || {}

  const eventContainer = findContainer(items) || {}
  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const { campaign } = defaultContext

  return (
    <EventsWrapper
      campaign={campaign}
      render={({ events }) => {
        const filtered = filterEvents(events, { limit, offset })

        return (
          <AnimationWrapper options={options}>
            <div style={style}>{renderEvents(eventContainer, filtered)}</div>
          </AnimationWrapper>
        )
      }}
    />
  )
}

Timeline.propTypes = {
  items: PropTypes.array,
  options: PropTypes.object,
}

export default Timeline
